import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GrammarRules = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M17.647 9.39a.917.917 0 0 1 0 1.297l-3.52 3.52a.917.917 0 0 1-1.296 0l-1.552-1.552a.917.917 0 0 1 1.296-1.297l.904.904 2.872-2.871a.917.917 0 0 1 1.296 0ZM17.647 20.012a.917.917 0 0 1 0 1.296l-3.52 3.52a.917.917 0 0 1-1.296 0l-1.552-1.552a.917.917 0 0 1 1.296-1.296l.904.904 2.872-2.872a.917.917 0 0 1 1.296 0ZM17.647 30.633a.917.917 0 0 1 0 1.296l-3.52 3.52a.917.917 0 0 1-1.294.003l-1.552-1.54a.917.917 0 1 1 1.291-1.302l.905.897 2.874-2.874a.917.917 0 0 1 1.296 0ZM20.47 11.799c0-.506.41-.917.917-.917h10.682a.917.917 0 0 1 0 1.834H21.387a.917.917 0 0 1-.917-.917ZM20.47 22.42c0-.506.41-.917.917-.917h10.682a.917.917 0 0 1 0 1.834H21.387a.917.917 0 0 1-.917-.917ZM20.47 33.041c0-.506.41-.917.917-.917h10.682a.917.917 0 0 1 0 1.834H21.387a.917.917 0 0 1-.917-.917Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M4.79 1.337c0-.507.41-.917.916-.917H38.29c.506 0 .917.41.917.917v42.166c0 .507-.41.917-.917.917H5.706a.917.917 0 0 1-.917-.917V1.337Zm1.832.916v40.334h30.752V2.253H6.622Z"
  })));
});
GrammarRules.displayName = 'GrammarRules';
GrammarRules.defaultProps = {
  'aria-label': 'GrammarRules'
};
export default GrammarRules;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/GrammarRules.js
// module id = 3178
// module chunks = 11